export const achievements = [
  // Beginner Achievements
  {
    id: 'first_game',
    name: 'Color Explorer',
    description: 'Play your first game',
    emoji: '🎨',
    type: 'games',
    target: 1,
    rarity: 'common',
    points: 10,
    reward: 'Welcome Badge'
  },
  {
    id: 'first_win',
    name: 'Perfect Match',
    description: 'Achieve 95%+ accuracy for the first time',
    emoji: '🎯',
    type: 'accuracy',
    target: 95,
    rarity: 'common',
    points: 25,
    reward: 'Accuracy Boost'
  },
  {
    id: 'score_1000',
    name: 'Rising Star',
    description: 'Score 1,000 points in a single game',
    emoji: '⭐',
    type: 'score',
    target: 1000,
    rarity: 'common',
    points: 50,
    reward: 'Star Badge'
  },

  // Intermediate Achievements
  {
    id: 'streak_5',
    name: 'On Fire',
    description: 'Achieve a 5-round winning streak',
    emoji: '🔥',
    type: 'streak',
    target: 5,
    rarity: 'rare',
    points: 75,
    reward: 'Fire Effect'
  },
  {
    id: 'score_5000',
    name: 'Color Master',
    description: 'Score 5,000 points in a single game',
    emoji: '🏆',
    type: 'score',
    target: 5000,
    rarity: 'rare',
    points: 100,
    reward: 'Master Title'
  },
  {
    id: 'perfect_10',
    name: 'Perfectionist',
    description: 'Achieve 10 perfect matches (99%+ accuracy)',
    emoji: '💎',
    type: 'perfect',
    target: 10,
    rarity: 'rare',
    points: 150,
    reward: 'Diamond Badge'
  },
  {
    id: 'games_50',
    name: 'Dedicated Player',
    description: 'Play 50 games',
    emoji: '🎮',
    type: 'games',
    target: 50,
    rarity: 'rare',
    points: 200,
    reward: 'Veteran Badge'
  },

  // Advanced Achievements
  {
    id: 'streak_10',
    name: 'Unstoppable',
    description: 'Achieve a 10-round winning streak',
    emoji: '⚡',
    type: 'streak',
    target: 10,
    rarity: 'epic',
    points: 250,
    reward: 'Lightning Effect'
  },
  {
    id: 'score_10000',
    name: 'Color Legend',
    description: 'Score 10,000 points in a single game',
    emoji: '👑',
    type: 'score',
    target: 10000,
    rarity: 'epic',
    points: 300,
    reward: 'Crown Title'
  },
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    description: 'Answer 25 questions in under 10 seconds each',
    emoji: '💨',
    type: 'speed',
    target: 25,
    rarity: 'epic',
    points: 200,
    reward: 'Speed Boost'
  },
  {
    id: 'games_100',
    name: 'Committed',
    description: 'Play 100 games',
    emoji: '🏅',
    type: 'games',
    target: 100,
    rarity: 'epic',
    points: 400,
    reward: 'Commitment Medal'
  },

  // Legendary Achievements
  {
    id: 'streak_20',
    name: 'Untouchable',
    description: 'Achieve a 20-round winning streak',
    emoji: '🌟',
    type: 'streak',
    target: 20,
    rarity: 'legendary',
    points: 500,
    reward: 'Legendary Aura'
  },
  {
    id: 'score_25000',
    name: 'Color God',
    description: 'Score 25,000 points in a single game',
    emoji: '🔱',
    type: 'score',
    target: 25000,
    rarity: 'legendary',
    points: 750,
    reward: 'Divine Title'
  },
  {
    id: 'perfect_50',
    name: 'Flawless Master',
    description: 'Achieve 50 perfect matches (99%+ accuracy)',
    emoji: '✨',
    type: 'perfect',
    target: 50,
    rarity: 'legendary',
    points: 1000,
    reward: 'Flawless Aura'
  },
  {
    id: 'games_500',
    name: 'Color Sage',
    description: 'Play 500 games',
    emoji: '🧙‍♂️',
    type: 'games',
    target: 500,
    rarity: 'legendary',
    points: 1500,
    reward: 'Sage Title'
  },

  // Special Achievements
  {
    id: 'no_hints',
    name: 'Self Reliant',
    description: 'Complete 10 games without using hints',
    emoji: '🚫',
    type: 'special',
    target: 10,
    rarity: 'rare',
    points: 150,
    reward: 'Independence Badge'
  },
  {
    id: 'hard_master',
    name: 'Hard Mode Hero',
    description: 'Win 25 games on Hard difficulty',
    emoji: '💪',
    type: 'difficulty',
    target: 25,
    rarity: 'epic',
    points: 300,
    reward: 'Hero Badge'
  },
  {
    id: 'time_master',
    name: 'Time Lord',
    description: 'Win 50 timed mode games',
    emoji: '⏰',
    type: 'gamemode',
    target: 50,
    rarity: 'epic',
    points: 250,
    reward: 'Time Badge'
  },
  {
    id: 'endless_warrior',
    name: 'Endless Warrior',
    description: 'Win 50 endless mode games',
    emoji: '♾️',
    type: 'gamemode',
    target: 50,
    rarity: 'epic',
    points: 250,
    reward: 'Infinity Badge'
  }
];